export default function Affix() {
  return {}
}
